import { render, staticRenderFns } from "./DrugFactIndex.vue?vue&type=template&id=7883ee96&"
import script from "./DrugFactIndex.vue?vue&type=script&lang=js&"
export * from "./DrugFactIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports